export default
{   "key00":"すべての",
    "key0": "ホーム",
    "key1": "マーケット",
    "key2": "ゲーム",
    "key3": "ブログ",
    "key4": "ゲームやグッズを探す",
    "key5": "言語 ",
    "key6": "通貨",
    "key7": "表示通貨は表示のみで、取引は米ドルのままです。",
    "key8": "確認する",
    "key9": "人気ゲーム",
    "key10": "すべてのゲーム",
    "key11": "ログイン",
    "key12": "登録する",
    "key13": "ポイント獲得",
    "key14": "私",
    "key15": "メッセージ",
    "key16": "レビュー",
    "key17": "売約済み",
    "key18": "もっと読む",
    "key19": "Steam&Switch CDKEY",
    "key20": "私たちを選ぶ理由",
    "key21": "100％安全な取引",
    "key22": "我々は、効率的、専門的かつ安全な取引サービスを提供することを約束します。我々は、プラットフォーム上であなたの取引に関わるプロセスおよび関連するデータ情報のセキュリティ保証を提供し、100％安全、ご安心ください。",
    "key23": "24時間365日サポート",
    "key23_2": "専任のサポートチームが、スムーズで楽しいゲーム体験をサポートします",
  "key23_3": "ゲームチャージ",
  "key23_4": "ゲーム内通貨や仮想資産のチャージで、手軽にゲーム体験を向上させましょう",
  "key23_5": "現地通貨",
  "key23_6": "ユーザーは好みの現地通貨で購入でき、面倒な通貨変換が不要です",
  "key23_7": "信頼できるストア",
  "key23_8": "ゲーム内資産購入のための安全で信頼できるプラットフォームを提供できることを誇りにしています",
    "key24": "私たちは強力なカスタマー・チームを擁し、複数の方法でご相談に応じます。売却前、売却中、売却後に必要なサポートを含め、お取引の過程で生じるあらゆるご質問に迅速かつ便利にお答えします。",
    "key25": "全額返金保証",
    "key26": "は、競争力のある商品価格とお客様のアカウントへの効率的な配送を提供します。もし商品が届かなかったり、配送後に使用できなかったりした場合、プラットフォームは100％の払い戻しを約束し、100％の金銭的保証を提供します。",
    "key27": "価格",
    "key28": "サイトナビゲーション",
    "key29": "源信インパクト・トップアップ",
    "key30": "本海スターレールトップアップ",
    "key31": "FC 25コイン",
    "key32": "変更",
    "key33": "乱闘スターズ",
    "key34": "アフィリエイト・プログラム",
    "key35": "利用規約",
    "key36": "プライバシーポリシー",
    "key37": "クッキーポリシー",
    "key38": "よくあるご質問",
    "key39": "お問い合わせ",
    "key40": "キャンセル",
    "key41": "口座情報",
    "key42": "アバター",
    "key43": "ニックネーム",
    "key44": "電子メール",
    "key45": "パスワード",
    "key46": "設定済み",
    "key47": "バインド",
    "key48": "保存",
    "key49": "お支払いについて",
    "key50": "注意：入力された住所が銀行口座/カードに関連付けられた住所と完全に一致することを確認してください。",
    "key51": "国を選択してください",
    "key52": "州を選択してください",
    "key53": "都市を入力",
    "key54": "アドレスを入力する",
    "key55": "郵便番号を入力",
    "key56": "Eメールを入力する",
    "key57": "電話を入力する",
    "key58": "完全なfirstNameを入力してください。",
    "key59": "姓をフルネームで入力",
    "key60": "通年",
    "key61": "全月を入力",
    "key62": "完全なCVVを入力してください。",
    "key63": "カード番号をすべて入力",
    "key64": "銀行カード番号",
    "key65": "CVV",
    "key66": "到期日期",
    "key67": "年",
    "key68": "月",
    "key69": "名字",
    "key70": "姓",
    "key71": "国/地域",
    "key72": "国を選択",
    "key73": "州を選択",
    "key74": "都市",
    "key75": "郵便番号",
    "key76": "住所",
    "key77": "電話",
    "key78": "電子メール",
    "key79": "今すぐ支払う",
    "key80": "ステータス",
    "key81": "迅速な配達",
    "key82": "安全性と信頼性",
    "key83": "配達即時トップアップ",
    "key84": "販売台数",
    "key85": "ご注文について",
    "key86": "入力内容を再度ご確認ください。",
    "key87": "貯蓄",
    "key88": "今すぐトップアップ",
    "key89": "セキュリティ保証",
    "key90": "数量",
    "key91": "価格",
    "key92": "サービス",
    "key93": "歴史を買う",
    "key94": "アカウント設定",
    "key95": "ヘルプセンター",
    "key96": "マイ・バランス",
    "key97": "私のポイント",
    "key98": "マイクーポン",
    "key99": "情報が必要",
    "key100": "加工",
    "key101": "払い戻し",
    "key102": "会社概要",
    "key103": "未払い",
    "key104": "ここに秩序はない",
    "key105": "申込番号",
    "key106": "有料",
    "key107": "時間",
    "key108": "ここに秩序はない",
    "key109": "に失敗",
    "key110": "検索",
    "key111": "アイテムが見つかりません",
    "key112": "検索結果",
    "key113": "トップ3の普及者",
    "key114": "利用規約",
    "key115": "プライバシーポリシー",
    "key116": "クッキーポリシー",
    "key117": "もうけを始める",
    "key118": "あなたのリンクを共有すると、ユーザーがあなたの共有リンクを使用してゲームをトップアップしたり、PlaySave.storeでゲームコインを購入するたびに、あなたはお金を稼ぐことができます。",
    "key119": "プロモーター・リーダーボード",
    "key120": "受注量",
    "key121": "収入",
    "key122": "どのような人がPlaySave.storeアフィリエイトプログラムに参加するのに適していますか？",
    "key123": "PlaySave.storeは、ゲーマーの皆様に割引価格とより良いサービスを提供することをお約束します。ゲームコミュニティで志を同じくする人々と協力することで、PlaySave.storeの影響力を拡大し、より多くのゲーム愛好家にサービスを提供できると信じています。もしあなたがゲームコンテンツクリエイター、YouTuber、ソーシャルメディアインフルエンサーなら、迷わずすぐにPlaySave.storeアフィリエイトプログラムに参加してください！",
    "key124": "PlaySave.storeのアフィリエイトプログラムでは、最高でいくら稼げますか？",
    "key125": "PlaySave.storeアフィリエイトプログラムのプロモーターは、発生した販売ごとに最大10％の利益を得ることができ、あなたの収益に上限はありません！",
    "key126": "幻神インパクトと本海外スターレールの新規ユーザーへの報酬基準は10％。",
    "key127": "他のゲームへのチャージやゲームコインの購入の報酬基準は5％です。",
    "key128": "報酬基準が調整される場合は、ウェブサイト上で公表される最新の調整内容を参照のこと。",
    "key129": "その他気になる質問",
    "key130": "報酬の収入は24時間以内に収入詳細で確認でき、毎週決済されます。引き出し、またはPlaySave.storeでゲームに直接チャージすることができます。",
    "key131": "プロモーションは合法的な手段で行われなければなりません。不正な手段によるプロモーションは認められません。Google Adsのような方法によるプロモーションは、コンテンツクリエイターの位置づけに合致せず、公平性の原則に違反し、また許可されません。PlaySave.storeはあなたの資金を凍結する権利を有します。",
    "key132": "ルールの設定により、特別な国のユーザーには特典が与えられない場合があります。事業展開により調整される可能性がありますので、ウェブサイト上で公表される最新の調整に従ってください。",
    "key133": 'メッセージ',
    "key134": "利用規約",
    "key135": "本規約について",
    "key136": "本契約は、お客様とGEARUP PORTAL PTE.Ltd.（以下、「当社」といいます）との間で締結されるものであり、本契約に基づき、ゲーム内のバーチャルアイテムおよびゲームトップアップ（以下、「バーチャルアイテム」といいます）を検索、購入することができるPlaySaveのアプリケーションまたはウェブサイト（以下、「本サービス」または「PlaySaveサービス」といいます）に関するものです。お客様は、本サービスにアクセスすることにより、本規約および本サービスに適用されるガイドラインまたは規則に拘束されることに同意するものとします。",
    "key137": "当社は、当社のアプリケーションまたはウェブサイトに変更後の規約を掲載することにより、本規約および適用されるガイドラインを随時更新することができるものとします。お客様が引き続き当社サービスを利用する場合、お客様は更新された規約に同意したものとみなされます。",
    "key138": "お客様は、本規約を電子的に入力すること、および本規約に関連する記録を電子形式で保存することに同意するものとします。",
    "key139": "PlaySaveは、バーチャルアイテムの検索、購入、ゲームのトップアップを可能にするオンラインウェブサイトです。",
    "key140": "当社のサービスにアクセスすることにより、あなたは、それぞれのユーザー契約および/または利用規約、および/またはゲームのポリシーの条項が、すべての点であなたに適用されることに同意するものとします。",
    "key141": "本サービスを利用するには、居住国の成人年齢に達している必要があります。",
    "key142": "PlaySaveサービスを利用するためには、SNSアカウント（LINE、Twitter、Facebookアカウント）からサインインする必要があります。バーチャルアイテムを購入する前に、お客様のゲームアカウントをバインドする必要があります。このバインドにより、お客様は、公開されているゲームプロフィールやバーチャルアイテムのリストを含むがこれに限定されない、特定のゲームユーザーアカウント情報へのアクセスおよび使用を許可することになります。当社がお客様から収集する個人データとその使用方法についての詳細は、当社のプライバシーポリシーをご覧ください。",
    "key143": "お客様は、ご自身のアカウント情報を保護し、秘密を保持するために必要な努力をすることに同意するものとします。お客様は、当社の事前の同意なしに、お客様のアカウントおよび本契約に基づくお客様の権利または義務を他人に譲渡したり、お客様のアカウント情報を他人と共有したりしないことに同意するものとします。",
    "key144": "ユーザーの行動とコンテンツ",
    "key145": "お客様は、当社サービスを利用する際、お客様が所在する司法管轄区の適用法または規制（マネーロンダリング/テロ資金供与対策に関する法律または規制を含む）、行政命令または措置、裁判所の判決または管轄当局の決定に従わなければなりません。適用される法律が当社サービスの利用を制限または禁止する場合、お客様はかかる制限に従うか、当社サービスへのアクセスを停止するものとします。",
    "key146": "次の各号のいずれかに該当する者であってはならない：",
    "key147": "組織犯罪グループのメンバー；",
    "key148": "組織的犯罪集団がその経営に実質的に関与していることを示すような、組織的犯罪集団との関係を有する者；",
    "key149": "組織的犯罪集団への依存を示すような関係を組織的犯罪集団と有する者；",
    "key150": "組織的犯罪集団に資金を提供することにより、組織的犯罪集団の維持・運営に協力・関与する者、またはそれに類似する行為。",
    "key151": "組織的犯罪集団と社会的に非難されるべき関係にある者。",
    "key152": "ユーザーは、本サービスを通じて、情報、データ、ソフトウェア、サウンド、写真、グラフィック、ビデオ、タグ、またはその他の素材（以下「コンテンツ」）を送信、アップロード、通信、伝送、またはその他の方法で提供することができます。ユーザーは、本サービスを通じて提供されるすべてのコンテンツについて、公開されたものであれ非公開で送信されたものであれ、排他的責任を負うものとします。",
    "key153": "利用者は、違法、有害、脅迫的、虐待的、嫌がらせ的、不法行為的、中傷的、低俗、わいせつ、名誉毀損的、他人のプライバシー侵害的、憎悪的、差別的、ポルノ的、性的、またはその他のコンテンツを提供しないものとします；",
    "key154": "利用者は、いかなる当事者の特許権、商標権、企業秘密、著作権またはその他の所有権を侵害するコンテンツも提供しないものとします；",
    "key155": "ユーザーは、チート、自動化ソフトウェア（ボット）、ハック、改造、または本サービスの一部を変更したり、本サービスから情報を収集したりするために設計されたその他の許可されていない第三者のソフトウェアを使用しないものとします；",
    "key156": "お客様は、当社サービス、他者が作成したコンテンツまたはその一部について、その全部または一部を問わず、リバースエンジニアリング、ソースコードの導出、修正、逆コンパイル、逆アセンブル、または派生物の作成を行わないものとします；",
    "key157": "お客様は、当社サービスに関連する特許表示、著作権表示、またはその他の知的財産情報を削除または修正しないものとします；",
    "key158": "バーチャルアイテムの購入とGameTopUp",
    "key159": "お客様は、PlaySaveサービスを利用する際に、取引に関するすべての条件を読み、理解することに単独で責任を負い、お客様の行為に関するすべての責任を負うものとします。",
    "key160": "PlaySaveは、アイテムおよびゲームトップアップの取引に起因する紛争を解決するために、ユーザーに対して必要なサポートを提供することができるものとします。",
    "key161": "返金ポリシー",
    "key162": "本利用規約または適用法に別段の定めがない限り、当社のサービス内での購入はすべて最終的なものであり、払い戻しはできません。当社は、お客様が本サービスを通じて行った支払いまたは取引の結果生じる可能性のある請求または損害について、お客様または第三者に対して一切の責任を負いません。",
    "key163": "PlaySaveでは、すべての注文は最終的なものであり、注文の代金を全額支払ったにもかかわらず注文を受け取らなかった場合を除き、返金は行われません。注文の対象となる仮想アイテム（以下「購入商品」）が未配送または一部未配送である限り、払い戻しは可能です。",
    "key164": NaN,
    "key165": "以下の場合、払い戻しはできません：",
    "key166": "バイヤーは、注文の受領を確認し、確認した。",
    "key167": "PlaySaveのウェブサイト以外で行われた取引。",
    "key168": "注文に基づいて納品された仮想アイテムに対する買い手の不満、買い手の後悔、誤って購入した仮想アイテム、および／または買い手のコンピュータが最低製品要件を満たしていないこと。",
    "key169": "ダイレクトトップアップでの間違った購入や間違いによる払い戻しはいたしません。最終チェックアウトに進む前に、商品説明をよく読み、ゲーム名、サーバー、アカウント名、購入金額が正確であることを確認する必要があります。当社は、過失および/または提供された虚偽または誤った情報により、お客様によって行われた誤ったまたは誤った注文について、一切の責任を負いません。",
    "key170": "不正請求。当社は、法的措置を追求し、不正請求を行ったバイヤーのアカウントを永久に停止する権利を留保します。",
    "key171": "PlaySaveのウェブサイトから製品を購入することにより、購入者は前述の除外事項を理解し、承認し、承諾するものとします。",
    "key172": "購入者が使用する支払い方法の種類にもよりますが、返金の処理には通常最大14日かかる場合があります。これは、銀行が通常すぐに返金を確定せず、資金の承認保留が期限切れになるまで最大14日かかる場合があるためです。",
    "key173": "免責事項",
    "key174": "当社は、お客様に正確で信頼できるサービスを提供するよう努めますが、お客様は、当社のサービスおよび情報が、いかなる種類の保証もなく、「現状のまま」提供されることを明示的に理解し、了承するものとします、これには、状態、中断のない使用、商品性、特定目的への適合性、非侵害、正確性、信頼性、またはバグ/エラー/欠陥のないことの保証が含まれますが、これらに限定されません。",
    "key175": "本規約に明示的に規定されている、または適用される法律で義務付けられている当社の責任を制限することなく、利用者は、当社が、以下に起因する、いかなる間接的、偶発的、特殊、結果的、または懲罰的損害に対しても責任を負わないことを明示的に理解し、同意するものとします、派生的または懲罰的損害賠償（利益、営業権、使用、データ、またはその他の無形損失の損失に対する損害賠償を含みますが、これらに限定されません）（たとえ当社がそのような損害賠償の可能性を知らされていたとしても）：(i)当社サービスを利用できないこと、(ii)当社サービスを通じて、または当社サービスから購入または取得した商品、データ、情報、またはサービス、または受信したメッセージ、または取引に起因する代替品およびサービスの調達コスト、(iii)お客様の送信またはデータへの不正アクセスまたは改ざん、(iv)当社サービスにおける第三者の発言または行為、または(v)当社サービスに関連するその他の事項。いかなる場合においても、契約、不法行為、厳格責任、またはその他に起因するか否かにかかわらず、当社の責任総額は、かかる請求が発生した時点の直前6ヶ月間に利用者が当社に支払った料金の総額を超えないものとします。",
    "key176": "違反および補償",
    "key177": "お客様が本規約または掲示されたガイドラインもしくは規則に違反したと当社が合理的に判断した場合、当社は適切と判断する措置を講じることができるものとします：(i) 関係するコンテンツを削除する、(ii) 当社のサービスにおいて提供される機能を停止する、(iii) お客様のアカウントを停止する、(iv) 当社のサービスを利用するお客様の権利を終了する、(v) お客様に対して法的措置を講じる、または法執行当局に関連情報を開示する、(vi) 掲載されたガイドラインおよび規則に規定されたその他の措置。",
    "key178": "お客様は、本契約に記載されたお客様と当社の関係に関連する、または本契約に記載されたお客様と当社の関係に起因する、あらゆる第三者からの請求、損失、損害、責任、費用、および経費（本契約の違反を含みますが、これらに限定されません）を補償し、当社に損害を与えないものとします。お客様は、当社が選択した弁護士を選択する権利、およびかかる請求、要求、または訴訟を妥協または解決する権利を含め、当社がかかる請求、要求、または訴訟に対する法的防御を管理する権利を有することに同意するものとします。",
    "key179": "知的財産",
    "key180": "PlaySaveおよび当社の関連ロゴおよび名称は、当社の商標および/またはサービスマークです。本サービスで使用されるその他のマーク、名称、およびロゴは、それぞれの所有者の商標、サービスマーク、またはロゴです。お客様は、前述の商標、サービスマーク、またはロゴに関して、いかなる権利またはライセンスも付与されません。",
    "key181": "本サービスおよびそれに関連するすべてのデータ、コンテンツ、ソフトウェアは、著作権法、商標法、特許法、企業秘密法、および/またはその他の法律によって保護されるものとし、当社は本サービスに関するすべての権利（知的財産権および所有権を含むがこれに限定されない）を留保し、保持するものとします。本契約の条件および適用される掲示されたガイドラインまたは規則に従い、当社はここに、当社サービスに関連して個人的に使用する場合に限り、当社サービスを使用および複製するための限定的、取消可能、サブライセンス不可、および非独占的ライセンスをお客様に付与します。本規約に明示的に規定されていない限り、お客様は当社サービスまたはその翻案物を複製、頒布、公衆送信、利用可能化、翻案、公的に上演、または公的に表示することはできません。本契約で付与されたライセンスは、お客様が本契約に違反した場合、自動的に終了します。一部のサービスは、アプリケーションまたは当社ウェブサイトに記載されているオープンソースライセンスなどの特定の第三者のライセンスの対象となる場合があります。特定のサービスを利用する際には、当該第三者のライセンス契約をよく読み、当該契約に規定された要件を遵守していることを確認してください。",
    "key182": "その他",
    "key183": "全体合意",
    "key184": "「本契約は、お客様と当社との間の完全な合意を規定するものであり、お客様と当社との間に存在する可能性のある他のあらゆる事前または同時の合意、理解、または交渉に優先し、これに取って代わるものです。 ",
    "key185": "可分性",
    "key186": "本契約のいずれかの条項が違法、執行不能、または無効であると宣言または認定された場合（ただし、その限りにおいてのみ）、お客様と当社の双方は、当該条項に基づいて生じるすべての義務から解放されるものとします。本契約は、その趣旨を維持しつつ、合法的かつ執行可能なものとするために必要な範囲で当該条項を修正することにより改正されるものとみなされることが、お客様と当社の意図であり、合意事項です。それが不可能な場合は、合法的かつ執行可能で、同じ目的を達成する別の規定で代用されるものとします。本契約の残りの部分が影響を受けず、実質的な履行が可能である場合、残りの部分は法律で認められている範囲で執行されるものとします。",
    "key187": "権利の放棄",
    "key188": "私たちは、本契約の条項をいつでも、またはいつでも実行できません。その条項を放棄したり、その後に各条項を実行する権利を放棄したりすると解釈されてはいけません。書面において本契約に明確に言及し、正式に署名しない限り、本契約のいかなる条項または条件の放棄も無効であるか、または私たちに拘束力がありません。",
    "key189": NaN,
    "key190": "お問い合わせ",
    "key191": "本利用規約または当社のプライバシー慣行についてさらにご質問がある場合は、PlaySaveウェブサイトの「お問い合わせサポート」からご連絡ください。",
    "key192": "言語",
    "key193": "本契約は、関連地域の現地語に翻訳される場合があります。英語版の本契約と現地語版の本契約が矛盾する場合は、英語版が優先するものとします。",
    "key194": "準拠法および裁判地",
    "key195": "適用される法律に別段の定めがない限り、本契約は、シンガポールの抵触法の規定にかかわらず、シンガポールで完全に履行、交渉、実行された契約として、シンガポールの法律に準拠するものとします。お客様の当社サービスまたは本契約の使用に関連する、または起因するあらゆる紛争は、シンガポール国際仲裁センター（以下、「SIAC」）が開催する仲裁に拘束されるものとします。お客様は、SIACにおける対人管轄権および裁判地に同意するものとします。お客様が欧州経済地域（EEA）の居住者である場合、お客様は、お客様が居住する国の法律（紛争解決地に関するものを含む）の強制規定の恩恵を受けるものとします。",
    "key196": NaN,
    "key197": "最終更新日:2024年8月26日",
    "key198": NaN,
    "key199": "ようこそ",
    "key200": "このプライバシーポリシーは、当社がどのように収集するかについての情報を提供します、 お客様の個人情報（以下「個人情報」といいます。 お客様が本サービスにリンクしている当社サービスを利用する際の「個人データ」（以下「個人データ」といいます。 プライバシーポリシー。また、お客様の法的権利と選択肢についても説明しています。 お客様の個人情報に関連する当社サービスへのアクセスおよび当社サービスの利用は、以下の条件に従うものとします。",
    "key201": "利用規約",
    "key202": "当社は、本プライバシーポリシーを随時更新することがあります。本プライバシーポリシーが更新された後も本サービスの利用を継続することにより、利用者は、個人情報が最新版に従って取り扱われることを了承するものとします。",
    "key203": "セクションにジャンプ",
    "key204": "個人情報",
    "key205": "当社が収集する個人情報",
    "key206": "個人情報の利用目的",
    "key207": "個人情報の共有方法",
    "key208": "プライバシー権の選択",
    "key209": "権利の行使",
    "key210": "広告マーケティングのオプトアウト",
    "key211": "クッキー 類似技術",
    "key212": "保護者の方へ",
    "key213": "地域情報",
    "key214": "米国居住者向け追加情報",
    "key215": "会社概要",
    "key216": "当社が収集する個人情報",
    "key217": "個人情報とは、以下のような個人に関する情報またはデータを指します。 特定または識別可能な個人。以下は 当社サービスの利用者について当社が収集する個人情報。",
    "key218": "「提供する情報:",
    "key219": "「お客様との対話の方法によっては、以下のうち1つまたは複数の提供をお願いすることがあります。 以下のような情報です。これらの情報は、本サイトの適切な運営に必要な場合にのみ収集されます。 お客様が提供することを選択した場合のみ",
    "key220": "身元、連絡先の人口統計学的詳細（例：氏名、スクリーンネーム、またはその他の同様の一意の識別子、役職、生年月日/年齢、国/地域、政府発行の身分証明書、電子メール/電話番号/郵便住所、メッセージング/ソーシャルアカウントID）",
    "key221": "「請求取引データ（請求先住所、支払口座または金融口座情報、詳細情報 お客様の購入および当社との取引について）",
    "key222": "アカウントのプロフィール情報（お客様が作成したアカウントのユーザー名とパスワード、セキュリティに関する質問と回答、アバター、第三者のソーシャルメディアまたはゲームプラットフォームのアカウントID、およびお客様がアカウントまたはプロフィールを通じて共有するその他の情報）",
    "key223": "「ユーザー生成コンテンツ（コンテンツ、アイテム、資産 お客様が当社サービス内で作成、共有、またはアップロードしたもの、お客様のフィードバック、 当社のサービスに関するレビューまたはコメント、お客様の投稿、コメント、および ソーシャルメディアサイトでのエンゲージメント）",
    "key224": "利用データの設定（クッキーおよび類似の技術に関する選択、ゲームプレイ設定、言語、および興味、その他の明示的な嗜好を含む、本サービスの利用方法および設定に関する情報）",
    "key225": "調査研究データ（ユーザー調査またはリサーチで任意に提供された情報）",
    "key226": "「マーケティング・プリファレンス お客様に表示または提供されるマーケティング/広告、 ニュースレター、アンケート調査、およびその他の情報の受信に関するお客様のご希望を含みます。 その他のプロモーション・コンテンツ)",
    "key227": "「当社とのコミュニケーション（当社への電子メール、チャット、その他のメッセージの内容）",
    "key228": "「当社が自動的に収集する情報一般的に 次のような情報を自動的に収集します。 当社サービスへの訪問、アクセス、または利用。",
    "key229": "「位置情報（都市／国／地域 IPアドレス、携帯ID、Wi-Fi接続に基づく)",
    "key230": "「デバイス、ネットワーク、技術情報（IP MACアドレスおよびその他類似のデバイス識別子、デバイスモデル、 オペレーティングシステム、地域/言語設定、インターネット 画面解像度、フレームレート、ping値； スタック情報（クラッシュレポートやコアダンプなど）とサーバー ヘルス・インジケータ（CPUやメモリの使用率、I/Oの使用率、負荷など）。 平均)、アクションやイベントの日付とタイムスタンプ。 サービス、その他のネットワークおよび技術情報）",
    "key231": " 第三者から収集する情報場合によっては、お客様に関する情報を第三者から受け取ることがあります。",
    "key232": " 「ソーシャルメディアまたはゲームプラットフォームのアカウント情報 サードパーティとのバインド、接続、またはログインを選択する際に、お客様によって承認される。 当社サービス上のアカウント（当社が受領する特定の情報 第三者によって異なり、お客様のプラットフォームアカウントが含まれる場合があります。 ID、プラットフォーム名、プロフィール写真、友達リスト、 privacy@PlaySave.store、年齢、国/地域; を確認または調整する。 プラットフォームから弊社に共有された情報については、以下のリンクをご参照ください。 アカウント設定)",
    "key233": " 「を選択した場合の支払情報 第三者決済処理サービス（ハッシュ化された識別子など、 お支払いの発信国／地域 取引の詳細)",
    "key234": " 「広告またはマーケティングデータ 当社サービス上の当社コンテンツへの関与、当社とのコミュニケーションにおける関与 他の関連サイトやアプリから送信される",
    "key235": " 「機密情報をお送りいただくことはご遠慮ください。 機微情報または「特別カテゴリーデータ」のようなデータ 社会保障番号、宗教、政治的信条、性的嗜好 オリエンテーション、人種/民族情報、犯罪歴、または取引に関する情報 組合/協会会員。",
    "key236": "個人情報の利用目的",
    "key237": "「当社は、個人情報を利用目的の範囲内でのみ利用します。 情報が収集されました。適用されるデータ保護法に基づく、 企業もまた、あなたの個人情報を処理する法的根拠を持たなければなりません。 情報を提供します。以下に、以下の目的と法的根拠について説明します。 個人情報の処理",
    "key238": "あなたの仕事",
    "key239": "収集するもの",
    "key240": "収集の理由",
    "key241": "法的根拠",
    "key242": "「サービスを利用する（例：ウェブサイトを訪問する、会員登録する）。 アカウント)",
    "key243": "身元、連絡先、人口統計学的詳細",
    "key244": "請求および取引情報",
    "key245": "アカウント＆プロフィール情報",
    "key246": "ユーザー作成コンテンツ",
    "key247": "利用データと嗜好",
    "key248": "調査・研究データ",
    "key249": "マーケティングの好み",
    "key250": "当社とのコミュニケーション",
    "key251": "ロケーション情報",
    "key252": "デバイス、ネットワーク、技術情報",
    "key253": "ゲームプレイ情報",
    "key254": "ソーシャルメディアまたはゲームプラットフォームのアカウント情報",
    "key255": "お支払いについて",
    "key256": "広告またはマーケティングデータ",
    "key257": "本サービスを運営し、お客様に提供するため：",
    "key258": "「を使用することで、当社のソフトウェアをダウンロード、インストール、実行することができます。",
    "key259": " 「あなたの好みをカスタマイズし、あなたに提供することができます。 オーダーメイドの体験で",
    "key260": "「他のユーザーとの交流が可能",
    "key261": "本サービスに関するお客様との連絡",
    "key262": "本サービスおよび当社事業のトラブルシューティングおよび改善のため、 を含む：",
    "key263": "システムのデバッグ、トラブルシューティング、診断テスト",
    "key264": "当社のシステムおよびサービスのパフォーマンス分析の実施",
    "key265": "新しいシステムおよびサービスの機能のテスト",
    "key266": "システムとログのメンテナンス",
    "key267": "技術サポートの提供",
    "key268": "「サービスの安全、安心、完全性を促進する、 を含む：",
    "key269": " 「不正、詐欺、詐欺師を特定し、防止し、取り締まる。 ハッキング、その他の禁止行為",
    "key270": "コミュニティ・スタンダードの管理",
    "key271": "不適切なコンテンツのモデレート",
    "key272": "ユーザー・レポートへの対応",
    "key273": "「当社の運営に関する法的義務を遵守するため などのサービスがある：",
    "key274": "年齢保証と検証の実施",
    "key275": "顧客を知る」要件を満たす",
    "key276": "正当な法的要請への対応",
    "key277": "帳簿および記録の管理",
    "key278": "当社の事業を運営・管理するため：",
    "key279": "内部監査の実施",
    "key280": "「合併、買収、その他の組織再編の促進 リストラクチャリング（見込み取引を含む）",
    "key281": "お客様との契約（利用規約）の履行",
    "key282": "あなたの同意、特定の目的に関連して 収集時に開示された処理",
    "key283": "当社の正当な利益:",
    "key284": "本サービスおよび当社事業の運営、トラブルシューティング、および改善",
    "key285": "「安全、安心、誠実さを社外に広める お客様との契約の履行",
    "key286": "ユーザーとサービスとの関わり方を理解する",
    "key287": "本サービスに関する内部分析の実施",
    "key288": "法的要件の遵守または法的権利の擁護",
    "key289": "「提供に関する法的義務の履行 サービス",
    "key290": " 「サービス・アカウントにサインアップするか、バインド、接続、ログインしてください。 サードパーティプラットフォームのアカウント",
    "key291": "身元、連絡先、人口統計学的詳細",
    "key292": "アカウント＆プロフィール情報",
    "key293": "利用データと嗜好",
    "key294": "当社とのコミュニケーション",
    "key295": "ロケーション情報",
    "key296": "デバイス、ネットワーク、技術情報",
    "key297": "ゲームプレイ情報",
    "key298": "ソーシャルメディアまたはゲームプラットフォームのアカウント情報",
    "key299": "お客様が本サービスにアカウント/プロフィールを設定できるようにすること、 カスタマイズ可能で継続的な経験を可能にする。 お客様のアカウントに関するご連絡",
    "key300": " 「アカウント作成に関する法的義務を遵守するため などのメンテナンスを行う：",
    "key301": "「年齢保証と検証の実施",
    "key302": "本人確認と情報の保護",
    "key303": "お客様との契約（利用規約）の履行",
    "key304": "アカウント設定時の同意",
    "key305": "本サービスの運営および改善のための当社の正当な利益 法的要件に従うため、または当社の法的権利を擁護するため",
    "key306": " 製品またはサービス（以下のようなデジタルコンテンツを含む）の購入 バーチャルグッズとバーチャルポイント)",
    "key307": "身元、連絡先、人口統計学的詳細",
    "key308": "請求および取引情報",
    "key309": "アカウント＆プロフィール情報",
    "key310": "利用データと嗜好",
    "key311": "当社とのコミュニケーション",
    "key312": "ゲームプレイ情報",
    "key313": "売買契約を履行するため。 ご注文商品の発送またはデジタルコンテンツへのアクセスの提供",
    "key314": "苦情や返金の管理など、消費者の購入に関する法的義務の遵守や法的権利の擁護のため",
    "key315": "お客様との契約（売買契約）の履行",
    "key316": "購入への同意",
    "key317": "「法的要件を遵守するための当社の正当な利益 法的権利を守る",
    "key318": "お客様の購入に関する当社の法的義務の履行",
    "key319": "位置情報機能の使用または有効化",
    "key320": "ロケーション情報",
    "key321": "「位置情報サービスおよびお客様が要求する機能を提供するため。 地域のゲーム内イベント、トーナメント、試合として",
    "key322": "お客様との契約（利用規約）の履行",
    "key323": "位置情報機能を有効にする際のお客様の同意",
    "key324": "カスタマーサポート",
    "key325": "身元、連絡先、人口統計学的詳細",
    "key326": "請求および取引情報",
    "key327": "アカウント＆プロフィール情報",
    "key328": "ユーザー作成コンテンツ",
    "key329": "利用データと嗜好",
    "key330": "当社とのコミュニケーション",
    "key331": "デバイス、ネットワーク、技術情報",
    "key332": "ゲームプレイ情報",
    "key333": "ソーシャルメディアまたはゲームプラットフォームのアカウント情報",
    "key334": "「本サービスに関するカスタマーサポートの提供 を含む：",
    "key335": " ユーザーからの問い合わせ、要求、コメントを促進し、対処する、 および苦情",
    "key336": "「ご要望の情報をお送りする",
    "key337": "本サービスの利用に関するお客様の支援",
    "key338": "「法律上の義務を遵守し、当社の法的権利を守るため 本サービスおよびカスタマーサポートの提供",
    "key339": "お客様との契約（利用規約）の履行",
    "key340": "特定のお問い合わせまたはご要望に関するお客様の同意",
    "key341": "「当社の正当な利益は、当社のユーザーとその方法を理解することです。 本サービスとの相互作用および法的要件の遵守 または当社の法的権利を守る",
    "key342": "カスタマーサポートに関する法的義務の履行",
    "key343": "「ニュースレターを購読するか、アンケートにご協力ください、 コンテスト、プロモーション",
    "key344": "身元、連絡先、人口統計学的詳細",
    "key345": "アカウント＆プロフィール情報",
    "key346": "利用データと嗜好",
    "key347": "調査・研究データ",
    "key348": "マーケティングの好み",
    "key349": "当社とのコミュニケーション",
    "key350": "デバイス、ネットワーク、技術情報",
    "key351": "ゲームプレイ情報",
    "key352": "ソーシャルメディアまたはゲームプラットフォームのアカウント情報",
    "key353": "広告またはマーケティングデータ",
    "key354": "当社のサービスを宣伝し、新しいリリースについてお知らせするため、 アップデート、オファー、調査、その他当社に関するニュース",
    "key355": " 「報酬、コンテスト、その他の情報をお知らせし、管理するため キャンペーン",
    "key356": " 「ユーザーベースとユーザーに関する分析・調査のため 当社のサービスを改善するための経験",
    "key357": "関連する通信に登録する際の同意",
    "key358": "「当社のサービスを改善し、促進するための正当な利益 選手との関係を管理する",
    "key359": " 「第三者のプラットフォーム上で当社または当社のコンテンツに関与すること。 例Facebookファンページ、Discordコミュニティ)",
    "key360": "身元、連絡先、人口統計学的詳細",
    "key361": "アカウント＆プロフィール情報",
    "key362": "利用データと嗜好",
    "key363": "コメント、投稿、フィードバック、レビューを促進し、それに応えること、 および当社サービスに関するその他のメッセージ",
    "key364": " 「事業運営、販売促進、および関与に関する当社の正当な利益 当社サービスに関心のある方",
    "key365": " データの保持 個人情報の保存期間 法的、規制上、税務上、会計上、またはその他の目的を満たすためなど、当社が個人情報を収集した目的を達成するために合理的に必要な期間。 報告要件。当社は、お客様の個人データをより長期間保持することがあります。 苦情が発生した場合、または法的請求の合理的な見込みがある場合は、その期間を延長する。",
    "key366": "「データ・セキュリティ：適切な管理を行います、 技術的、物理的な安全保護措置により、お客様の情報を次のような脅威から保護します。 偶発的または不正な紛失、誤用、アクセス、開示、改変、 または破壊。不正な開示に気づいた場合 情報を提供する場合は、法律で義務付けられている通り、お客様に通知し、以下の措置を講じます。 あなたの情報を保護します。しかしながら、いかなるインターネット通信も、完全に安全でエラーのないものではありません。",
    "key367": "個人情報の共有方法",
    "key368": "私たちはあなたの連絡先の詳細（お名前、電話番号など）を共有することはありません、 電子メール、または郵送先住所）を独立した第三者と、お客様の許可なく共有することができます。 ただし、本プライバシーポリシーに記載されている限定的な目的についてはこの限りではありません。 ポリシー（利用規約の実施、本サービスの安全確保、または法律もしくは法的手続きにより要求された場合など）。当社はお客様の情報を販売しません。",
    "key369": " 当社は、以下のとおり、個人情報を第三者と共有します：",
    "key370": "「ソーシャルメディアとゲームプラットフォームあなたが サードパーティのソーシャルメディアまたはゲームとのバインド、接続、ログイン プラットフォーム・アカウントは、サードパーティ・サービスが以下の情報を受け取る可能性があります。 各社は、各自が定めるところに従い、ユーザーが当社サービスとどのように相互作用するかについて、以下の情報を提供します。 プライバシーポリシーに従います。(例えば、Xbox アカウントを使用してログインする場合 マイクロソフトは、あなたが当社のゲームにログインしたという情報を受け取ることがあります。 をゲームに追加してください)。当社は、これらの第三者のプライバシー慣行を管理することはできません。 そのため、第三者機関のポリシーを必ず確認してください。 あなたが利用するサービス。",
    "key371": " 「サービスプロバイダー当社はお客様の情報を以下と共有します。 説明された目的のために当社に代わって業務を行うサービスプロバイダー 上記（「個人情報の利用目的」参照）。サービスプロバイダーは、当社のサービスに従って当社のサービスをサポートします。 の指示を受け、情報を安全に処理することが求められる。 (サービス・プロバイダーの例としては、クラウド・サービス、決済サービスなどがある プロセッサー、ユーザーリサーチプロバイダー、マーケティングおよび広告会社 ネットワーク)",
    "key372": " 関連会社当社は、本プライバシーポリシーに沿った目的のため、関連会社および子会社とお客様の情報を共有します。",
    "key373": " 事業譲渡に巻き込まれた場合 企業の売却、合併、組織再編、解散、または同様の出来事、 またはそのような事象に関連するデューデリジェンスに、あなたの情報が含まれる場合があります。 譲渡資産の",
    "key374": "「法的要件と被害防止私たちは 当社が合理的と判断した場合、お客様の情報を開示します。 法律、規制、またはその他の法的手続きに従うために必要な場合。 義務当社は、当社への危害を防止するために、お客様の情報を開示することがあります。 当社のユーザーを守るため、または当社の権利およびユーザーの権利を守るため。",
    "key375": " 「データ転送：当社のサービスプロバイダー 関連会社、子会社、パートナーは世界各国にある。 世界お客様の個人情報は、以下の場所に転送されることがあります。 これらの国々で加工される。 お客様が居住する国。これらの国々には、以下のようなデータ保護法が存在する場合があります。 は、あなたの法域のものとは異なる（場合によっては、あなたの法域のものであってもよい）。 保護的ではない)。これらの主体は、情報の処理にコミットする。 適用されるデータ保護法を遵守し、以下を実施する。 お客様の情報を保護するための適切なセキュリティ対策",
    "key376": "「EEA / UK / Switzerland:これらの国から個人情報を転送する場合、当社は以下の保護措置を実施します：",
    "key377": " 「妥当性決定：カナダ、日本、英国へのデータ移転については、適切性決定に依存しています。 英国はこちら、スイスはこちら）。 ",
    "key378": "標準契約条項当社は、シンガポールや香港など、適切でないと考えられる国への移転については、欧州委員会および英国ICOが発行した標準契約条項に依拠しています。お客様は、当社に連絡することにより、これらの措置の写しを入手することができます。",
    "key379": "プライバシーに関する権利と選択",
    "key380": "権利の行使",
    "key381": "お客様がお住まいの地域によっては、お客様の個人情報に関する以下の権利の一部または全部を有する場合があります。ただし、これらの権利は絶対的なものではなく、特定の状況においてのみ適用される場合があります。",
    "key382": "アクセスとポータビリティ：個人情報へのアクセスまたはコピーの要求。",
    "key383": "削除個人情報を削除します。",
    "key384": "訂正お客様の個人情報が不正確である場合、訂正または更新を行います。",
    "key385": "異議申し立てお客様の個人情報の処理に反対する、またはお客様の個人情報の処理を制限するよう求める。",
    "key386": "同意の撤回：該当する場合、同意を撤回する前に既に行われていた処理や、他の合法的な理由に基づく個人情報の処理に影響を与えることなく、同意を撤回することができます。",
    "key387": " 苦情お客様の個人情報の取り扱いについて、データ保護当局に苦情を申し立てます。",
    "key388": "お客様は、お客様がお住まいまたはお勤めのEEA加盟国、または当社がデータ保護法を侵害したと思われるEEA加盟国のデータ保護当局、またはお客様に適用される英国情報コミッショナー事務局に申し立てを行うことができます。",
    "key389": "お客様は、PRIVACY@PlaySave.store、ご自身のプライバシー権を行使するための要請を当社に提出することができます。その際、件名に「プライバシー権行使要求」と明記してください。当社は、これらの権利の行使を理由にお客様を差別することはありません。",
    "key390": "お客様の身元を確認し、不正なリクエストから保護するために、当社は、お客様のリクエストを処理する前に、お客様の身元および当社とのやりとりに関する詳細な情報を要求することがあります。お客様が当社でパスワードで保護されたアカウントを保持している場合、当社はお客様のアカウントに関する既存の認証慣行を通じてお客様の身元を確認することがあります。",
    "key391": "当社があなたの要請を拒否した場合、あなたは当社に連絡して当社の決定に異議を申し立てることができます。",
    "key392": "広告とマーケティングのオプトアウト",
    "key393": "当社は、広告およびマーケティングプロバイダと提携し、当社のサービスに関する広告を配信し、第三者サービスにおける当社の広告パフォーマンスを測定します。法律で義務付けられている場合、当社は広告およびマーケティング目的でお客様の情報を共有する前にお客様の同意を求めます。お客様は、PRIVACY@PlaySave.store まで電子メールを送信することにより、いつでも同意を撤回またはオプトアウトすることができます。",
    "key394": "当社はまた、電子メールおよびプッシュ通知を使用して、本サービスに関するマーケティングメッセージを送信します。電子メールメッセージの配信を停止するには、電子メールに記載されている配信停止手順に従っていただくか、PRIVACY@PlaySave.store までご連絡ください。プッシュ通知を無効にするには、デバイスの設定で関連するアプリを選択してください。",
    "key395": "クッキーと類似技術",
    "key396": "当社は、ブラウザの種類、本サービスの利用時間、閲覧したページ、言語設定、その他のトラフィックデータなどの情報を収集するために、クッキーおよび類似の技術を使用しています。当社は現在、ブラウザのDo-not-trackシグナルに応答していません。クッキーの使用方法についての詳細、またはクッキーの収集と使用からのオプトアウトについては、ご利用の特定のサービスに適用されるクッキーポリシーをご覧ください。",
    "key397": "お使いのブラウザでは、すべてのクッキーを削除したり、特定のサイトからのクッキーのみを許可したり、クッキーが送信されるタイミングを表示したりすることができます。一般的なブラウザでクッキーを管理する方法については、以下をご覧ください：Internet Explorer、Firefox、Chrome、Safari（iOS）、Safari（Mac）、Opera。必要なクッキーを無効にすると、サイトが正しく機能しなくなるため、無効にすることはできません。",
    "key398": "保護者の方へ",
    "key399": "当社のサービスは、一般の利用者を対象としています。低年齢のプレイヤーにアピールする可能性のある特定のサービスについては、プレイヤーの年齢を確認し、子供の個人情報の処理について確認可能な親の同意を必要とし、子供のプライバシーを保護するために高度なプライバシーバイデフォルト設定を実装するための措置を講じています。これらの措置には以下も含まれます：",
    "key400": "お子様からどのような個人情報を収集、使用、開示する可能性があるかについて、保護者の方にサービス固有のプライバシー通知を提供すること。",
    "key401": "法律で義務付けられている通り、子どもの個人情報を処理するために、検証可能な保護者の同意を求めること。",
    "key402": "児童の個人情報の処理を、本サービスを提供するために合理的に必要な範囲に限定すること。",
    "key403": "子供のプライバシー設定を可視化し、きめ細かくコントロールできるようにするペアレンタル・コントロールの提供。",
    "key404": "特に若い選手向けにプライバシー情報を提供する。",
    "key405": "保護者はいつでも、privacy@PlaySave.store までご連絡いただくことにより、お子様の個人情報の処理に関する許可を取り消したり、お子様のアカウントに関連して当社が収集した個人情報の削除を依頼したりすることができます。",
    "key406": "お子様が、同意なしに個人情報を処理するサービスを利用していると思われる場合は、privacy@PlaySave.store。",
    "key407": "本条において、「児童」または「子ども」とは、現地の適用法で求められるデジタル同意年齢に満たない未成年者を意味します（例えば、英国ではデジタル同意年齢は13歳です）。(例えば、英国におけるデジタル同意年齢は13歳です)。",
    "key408": "地域情報",
    "key409": "アメリカ居住者向け追加情報",
    "key410": "このセクションでは、上記の情報を補足し、当社のサービスを利用する米国の消費者について当社が収集する個人情報の収集、使用、および開示方法についてさらに説明します。",
    "key411": "個人情報の収集と使用上記で詳述したとおり、当社はさまざまな目的で個人情報を収集しますが、当社が情報を収集する主な理由は、本サービスを提供および運営するためです。当社が収集する個人情報は以下のとおりです：",
    "key412": "識別子（ユーザー名、privacy@PlaySave.store、IPアドレス、デバイス識別子、その他類似の識別子を含む、連絡先情報および固有の個人識別子）；",
    "key413": "カリフォルニア州の顧客記録法で定義されている個人情報（連絡先情報、お客様が提供することを選択した場合、身体的特徴や説明など）；",
    "key414": "デモグラフィック情報（生年月日/性別）の形で保護されたクラスの特性（提供することを選択した場合）； 商業情報（購入または消費履歴、傾向、または嗜好）；",
    "key415": "インターネットまたは電子ネットワークの活動（アプリ、ゲーム、またはウェブサイトの使用に関連する情報）；",
    "key416": "おおよそのジオロケーションデータ（国/地域）；",
    "key417": "音声、電子的、視覚的、または類似の情報（プロフィール写真、ユーザー作成コンテンツ、音声チャットなど）；",
    "key418": "適用法で定義されるその他の「個人情報」（お客様のクレジットカードまたはデビットカード情報など）；",
    "key419": "これらのカテゴリーから導き出される推測（例えば、IPアドレスに基づくあなたの都市/国/地域）； ",
    "key420": "アクセス認証情報と組み合わせたアカウントログインに関する機微な個人情報。",
    "key421": "個人情報の利用目的」には、お客様の個人情報を収集する業務上および商業上の目的が記載されています。個人情報の共有方法」のセクションでは、当社が個人情報を共有する第三者とその目的について説明します。",
    "key422": "お客様の権利上記の「お客様の権利の行使」に記載されているプライバシーの権利に加えて、お客様は以下の権利を有する場合があります：",
    "key423": "販売をオプトアウトする権利：利用者は、当社が利用者のデータを販売するかどうかを知る権利、および当社が販売する場合にその販売からオプトアウトする権利を有します。当社はユーザーの個人情報を販売することはありません。",
    "key424": "行動広告のための共有をオプトアウトする権利：お客様は、行動広告を目的とした個人情報の共有をオプトアウトする権利を有します。この共有のオプトアウトは、アプリ内のカスタマーサービスまたは電子メール（privacy@PlaySave.store）でご連絡ください。",
    "key425": "委任された代理人書面または委任状により、お客様の権利を行使するためにお客様に代わって要請を行う権限を有する代理人を指定してください。代理人からのこのような要請を受理する前に、当社は代理人に対し、お客様が代理人として行動することを承認した証拠を提出するよう要求します。",
    "key426": "一部のブラウザ・プラグインは、グローバル・プライバシー・コントロール（「GPC」）などのオプトアウト・プリファレンス・シグナルを伝達するためのオプションを提供しています。当社は、GPCシグナルを、GPCシグナルを送信したお客様のブラウザまたはデバイスに関連するターゲット広告または個人情報の「共有」をオプトアウトする要求として取り扱います。お客様がアカウントにログインしていない場合、お客様のブラウザまたはデバイスとアカウントとの接続は当社には分からないため、GPCシグナルによる要求はいかなるアカウント情報にも及びません。",
    "key427": "当社は、ダイレクトマーケティングを目的として個人情報を第三者と共有することはありません。",
    "key428": "当社は、16歳未満の未成年者の個人情報を故意に「販売」または「共有」することはありません。",
    "key429": "公開投稿コンテンツの削除。お客様がカリフォルニア州在住で本サービスの登録ユーザーである場合、お客様は、privacy@PlaySave.store 宛てに電子メールを送信するか、ゲーム内のカスタマーサービスに連絡することにより、お客様が18歳未満であったときに本サービスに投稿したコンテンツまたは情報を削除するよう当社に要請することができます。この要請は、コンテンツまたは情報の完全または包括的な削除を保証するものではないことにご注意ください。たとえば、あなたのコンテンツの一部が他のユーザーによって再投稿されている可能性があります。",
    "key430": "会社概要",
    "key431": "準拠法上、Gearup Portal Pte.Ltd.は、本サービスを通じて収集された個人情報の「データ管理者」です。当社の郵送住所は、1 Raffles Quay #49 Singapore 048583です。この個人情報保護方針についてご質問がある場合は、当社の郵送先住所または電子メール（privacy@PlaySave.store）にご連絡ください。",
    "key432": NaN,
    "key433": "取引プラットフォームへのログイン方法を教えてください？",
    "key434": "PlaySave.storeのリンクから取引プラットフォームに入ります。右上のログインボタンをクリックしてログインします。",
    "key435": "Eメール、Google、LINE、Facebook、Twitter、Appleのアカウントを使用して取引プラットフォームにログインできます。デフォルトでは、初回ログイン時にプラットフォームアカウントを登録する必要があります。",
    "key436": "複数のソーシャルメディア・アカウントにリンクするには？",
    "key437": "各ソーシャルメディアは1つのプラットフォームアカウントにのみリンクできます。Personal Center -> Account Settingsから別のプラットフォームアカウントにリンクすることができます。ソーシャルメディアアカウントをプラットフォームアカウントにリンクすると、どちらのアカウントでも取引プラットフォームにログインすることができます。今後、ソーシャルメディアアカウントのリンクを解除することはできません。",
    "key438": "アカウントをEメールにリンクする方法は？",
    "key439": '取引プラットフォームにログインし、「Account Information」に進みます。Eメールを探し、"Link email" をクリックします。',
    "key440": "アカウントとリンクさせたいEメールアドレスを入力してください。このEメールにアクセスできることを確認してください。入力が終わったら、「送信」をクリックします。",
    "key441": "Eメールにログインし、受信トレイに認証コードメールが届いていないか確認してください。届かない場合は、60秒後に再度「送信」ボタンをクリックしてください。",
    "key442": "検証コードメールを開き、中に検証コードが記載されていることを確認します。取引プラットフォームに戻り、認証コードを入力し、Eメールのリンクプロセスを完了します。",
    "key443": "現在、取引プラットフォームはリンクされた電子メールの変更をサポートしていません。すべての電子メールは1つのプラットフォームアカウントにのみリンクすることができます。ご不明な点がございましたら、ヘルプセンター->カスタマーサービスまでお問い合わせください。",
    "key444": "言語と通貨を変更するには？",
    "key445": "サイトナビゲーションで現在設定されている言語通貨を見つけ、それをクリックして設定を変更することができます。",
    "key446": "また、言語や通貨の設定は、ログイン後の「パーソナルセンター-環境設定」で変更できます。",
    "key447": "取引手数料",
    "key448": "ダイレクト・リチャージ・サービス：",
    "key449": "ダイレクトチャージサービスには、決済処理手数料を除き、追加料金はかかりません。チャージ金額は、ゲームパブリッシャーが設定する価格に基づいて調整されます。実際の金額についてはチャージページをご参照の上、お支払いを完了してください。",
    "key450": "アイテム取引サービス：",
    "key451": "売主の手数料販売価格の12％の手数料が販売者に請求されます。キャンペーン期間中は手数料が変動する場合がありますので、実際の手数料をご参照ください。バイヤー手数料：0％ リチャージ手数料：リチャージページをご確認ください。出金手数料出金ページにてご確認ください。チャージまたは出金ページで金額を入力すると手数料が計算されます。",
    "key452": "直接充電時間",
    "key453": "お支払いが完了すると、10分以内にダイレクトチャージサービスがアカウントに入金されます。ピーク時や特別なイベント時には、遅延や不着が発生する可能性がありますが、24時間以内に自動的に入金または返金される予定です。ご注文についてご不明な点がございましたら、カスタマーサービスまでお問い合わせください。",
    "key454": "ダイレクト・リチャージの記録を確認するには？",
    "key455": '注文状況は "パーソナルセンター - 購入記録" で確認できます。注文が成功したと表示された場合、ゲームアカウントにログインして対応する資産の増加を確認できます。また、ゲームからポップアップやゲーム内メールでリマインダーが送信されることもあります。',
    "key456": "ダイレクト・チャージ情報が入力されている場合",
    "key457": "「重要な注意事項取引プラットフォームは、利用者の過失、虚偽または不正確な情報の提供、またはその他の理由によるエラーについて、いかなる責任も負いません。注文が完了した後は、キャンセルや払い戻しはできません。",
    "key458": "ご注意ください：",
    "key459": "1.お支払いの前に、ゲームアカウントID、ユーザー名、サーバーなどのリチャージ情報をご確認ください。",
    "key460": "2.サービスプロバイダの要求により、リチャージ注文が完了すると、キャンセルや払い戻しはできません。新たなリチャージを開始することはできますが、取引プラットフォームは誤った購入問題に対して責任を負いません。",
    "key461": "3.ゲームIDの入力に誤りがあり、リチャージに失敗した場合は、入力内容の誤りを確認後、自動的に返金されます。ダイレクトチャージサービスのご注文についてご不明な点がございましたら、カスタマーサービスまでお問い合わせください。",
    "key462": "ダイレクト・リチャージ・サービスが加算されない場合は？",
    "key463": "アカウント？",
    "key464": "ダイレクトチャージサービスがアカウントに入金されず、注文が返金されない場合は、支払いが成功し、未着であることを証明する関連証拠を提出し、カスタマーサービスにお問い合わせください。プラットフォームのカスタマーサービスがリチャージがゲームアカウントに到着していないことを確認した場合、払い戻しが処理されます。",
    "key465": "KYC本人確認とは何ですか？なぜこのプロセスを完了する必要があるのですか？",
    "key466": "PlaySave.storeのKYC認証は、ユーザーの身元を確認するための支払い認証です。",
    "key467": "KYC照合は、Payment Card Industry Data Security Standard (PCI) とFinancial Action Task Force (FATF)のマネーロンダリング防止に関する要件に基づいて設計されており、ユーザーの支払い／引き出しが指定されたルールに達した場合にトリガーされる。主な目的は、ユーザーのカード・セキュリティを保護し、代理チャージによるマネーロンダリング犯罪を防止することである。",
    "key468": "身分証明書、健康保険証、運転免許証、学生証など、本人であることを確認できる書類をご用意ください。",
    "key469": "お客様の個人情報は絶対に安全であり、PlaySave.storeはユーザーのプライバシーを収集または開示することはありませんのでご安心ください。",
    "key470": "KYC本人確認を受けるように言われましたが、本人確認プロセスは安全ですか？その場合、提出した書類はどのように保管され、使用されるのですか？",
    "key471": "PlaySave.storeでは、お客様の個人情報をご提供いただくにあたり、お客様の信頼を第一に考えております。PlaySave.storeは、PlaySave.storeのウェブサイト上でオンラインで収集された個人を特定できる情報（お名前、ご住所、携帯電話番号、Eメールアドレスなど）を、マーケティング以外の目的で、関係のない他の企業や組織と共有、開示、販売することはありませんのでご安心ください。",
    "key472": "KYC認証に失敗する理由とその対策は？",
    "key473": "KYCは実名認証の仕組みです。ユーザーの資産の安全性を確保するため、PlaySaveはトップアップと引き出しの際にユーザーのKYC認証を要求している。",
    "key474": "KYC認証が失敗した場合、以下のような理由が考えられる。",
    "key475": "1.提出した実名認証証明書が新規発行されたもので、証明書情報が対応する管理センターに同期されていない。",
    "key476": "2.証明書情報が不完全または不適格である。",
    "key477": "3.認証に失敗しました。",
    "key478": "KYC認証が不合格または制限に達した場合はどうすればよいですか？",
    "key479": "実名認証によるご不便をご理解ください。以下の手順で個人情報を送信していただければ、手動審査で対応させていただきます。",
    "key480": "ヘルプセンター--カスタマーサービス」をクリックする。",
    "key481": "フィードバック分類はKYC認証を選択する。",
    "key482": "氏名、ID番号、証明書の種類（IDまたはパスポート）を記入する。",
    "key483": "IDを持っている写真をアップロードする（写真参照）",
    "key484": "あなたのIDとPlaySaveの情報ページの写真をアップロードしてください（写真を見るには、ユーザー名とアバターがはっきり見える必要があります）。",
    "key485": "上記の情報は、KYC確認プロセスに必要なものであり、お客様の個人情報は、このセキュリティ確認のためにのみ使用されます。PlaySaveは、お客様の個人情報を厳重に保護することをお約束します。手動認証の完了には約1営業日かかります。",
    "key486": "銀行カードでトップアップするには？",
    "key487": "クレジットカードを使用して取引プラットフォーム上でトップアップを実行できます。トップアップチャネルオペレーターは、各トランザクションに一定の管理手数料を請求する場合があります。トップアップページで金額を入力すると、具体的な手数料が表示されます。",
    "key488": "トップアップバリューは商品の購入にのみ使用でき、引き出しはできない。",
    "key489": "銀行カードをお客様の口座にリンクする際は、以下の情報が正しいことをご確認ください：",
    "key490": "氏名、国・地域、詳細な住所などの個人情報。カード発行会社または銀行に提供した詳細情報と一致していること。",
    "key491": "カード番号とカード確認コード（CVC）。",
    "key492": "注釈:",
    "key493": "*1回のトップアップは500米ドルまで。トップアップは1日10回、1カ月に最大50回まで。",
    "key494": "*各PlaySaveアカウントに追加できる銀行カードは5枚までです。ただし、すべての銀行カードのカード所有者名は同じでなければなりません。",
    "key495": "*トップアップに失敗した場合は、トップアップのページでシステムから提供された理由を確認してください。問題を解決し、再度お試しください。",
    "key496": "*トップアップの回数には制限があります。トップアップを実行する前に、銀行カードに十分な残高があることを確認してください。トップアップに失敗した場合は、トップアップのページで原因を確認し、問題を解決してください。トップアップに失敗した場合も、限度額にカウントされますのでご注意ください。",
    "key497": "*ご不明な点がございましたら、カスタマーサービスまでお問い合わせください。",
    "key498": "クレジットカードなしでチャージするには？",
    "key499": '取引プラットフォームは、電子財布決済、銀行振込、コンビニ決済など、複数の決済方法に対応しています。利用可能な支払い方法は、"パーソナルセンター "の "マイウォレット "ページで確認できます。',
    "key500": "コンビニ支払いの注意点は？",
    "key501": "現在、このプラットフォームはファミリーマートやローゼンなどのコンビニエンスストアでの支払いに対応している。トップアップ情報を入力した後、対応するコンビニエンスストアでオフラインで支払うことができる。",
    "key502": "ご注意ください",
    "key503": "(1)リチャージを開始しても、購入手続きに入ったことにはなりません。現時点では、リチャージ資金は個人の残高にチャージされるだけです；",
    "key504": "(2)国際決済のため、コンビニ決済後、上乗せが到着するまで通常3時間程度かかりますので、気長にお待ちください。コンビニ決済が長時間到着しない場合は、「カスタマーサービス」をクリックしてフィードバックすることができます。",
    "key505": "各トップアップの最低額と最高額はいくらですか？",
    "key506": "VisaまたはMastercardを使った1回のトップアップの最低額はUSD10で、最高額はUSD5,000である。",
    "key507": "上乗せ料金はいくらですか？",
    "key508": "銀行はこの取引に一定の管理手数料を請求します。詳しくは、パーソナルセンター -> マイ・ウォレットのトップアップページをご覧ください（ログインが必要です）。",
    "key509": "現在、VisaまたはMastercardのトップアップの手数料は3.5% + USD0.15です。これはほとんどの国に適用されます。(アルゼンチン、ブラジル、コロンビア、ナイジェリア、シンガポールの銀行カードは現在サポートされていません。また、ロシアの関係者が関与する取引は、不明な理由により失敗する可能性があります)。",
    "key510": "トップアップ・エラーとその解決方法",
    "key511": "トップアップ・リクエストが失敗した場合、トップアップ・エラーの原因をよく確認してください。それぞれのエラーの解決方法は以下の通りです。",
    "key512": "(1)1回のトップアップ限度額を超えている トップアップ注文で「Do Not Honor」または「Suspected Fraud」などのエラーメッセージが表示された場合は、トップアップ限度額を超えているため、セキュリティ警告が作動した可能性があります。1回のトップアップ額をUSD100未満に抑え、再度お試しください。",
    "key513": "(2) 支払い当事者が取引を拒否するその他の理由 トップアップ要求が失敗した場合、ほとんどの場合、取引プラットフォームではなく、支払い当事者によって取引が拒否されたためです。考えられる理由は以下のとおりです：",
    "key514": "銀行口座の残高が不足している",
    "key515": "銀行カードが制限されている",
    "key516": "支払側が取引を拒否する理由の詳細については、支払側に直接お問い合わせください。",
    "key517": "また、取引プラットフォームは、以下の場合、トップアップ要求を拒否することができる：",
    "key518": "2つ以上の異なる取引プラットフォーム口座を同じクレジットカードにリンクさせようとした。",
    "key519": "トップアップの上限に達している 取引プラットフォームでは、トップアップ取引に失敗した場合の手数料は徴収されません。以下の方法で再度トップアップをお試しください：",
    "key520": "リンク先の銀行カードを変更する",
    "key521": "別のブラウザまたはPCを使用する",
    "key522": "少量ずつ複数回の補給を行う",
    "key523": "ブラウザのポップアップ警告ブロック機能を有効にする",
    "key524": "トップアップ取引に関するご質問は、「カスタマーサービス」をクリックしてお問い合わせください。",
    "key525": "銀行カードで出金するには？",
    "key526": "引き出しページでは、銀行口座への引き出しを選択することができます。ほとんどの場合、出金リクエストは1日以内に審査・承認され、1～5営業日以内にお客様の口座に入金されます。具体的な所要日数は、ご利用の銀行によって異なります。",
    "key527": "出金に失敗した場合は、出金ページで原因を確認してください。可能であれば問題を解決し、再度お試しください。",
    "key528": " また、日本では規制が厳しくなっているため、日本地域のユーザーは退会フォームに以下を記入してください：",
    "key529": '支払いチャンネルで要求されるように、"First name "と "Last name "を英語で記入してください。',
    "key530": '市町村、番地、番地など、詳しいご住所をご記入ください。住所は以下の形式で記入することをお勧めします：「No. XXX, XXX Road, XXX Street".番地が数字のみの場合は、以下のようにご記入ください：「XXX町1-2-1203」とご記入ください。',
    "key531": "現地出金を選択した場合、口座名はカタカナまたは英語でなければなりません。スウィフト送金を選択した場合、口座名は英語でなければなりません。",
    "key532": "口座名義は姓と名を同じにし、いずれもカード名義人の本名でなければならない。言語の優先順位は以下の通りです：英語 > カタカナ",
    "key533": "出金リクエストを送信した後、プラットフォームまたはチャネルがリクエストを確認します。出金依頼のステータスが「承認」に変更された場合、資金は1～5営業日以内にお客様の口座に入金されます。",
    "key534": "トップアップ残高を引き出すことはできません。お引き出しできるのは、アイテムの販売で得た収益のみです。お引き出しの上限額は1回につき2,000米ドルです。ユーザーは1日に5回引き出しが可能で、1年間の引き出し総額は20,000米ドルを超えることはできません。",
    "key535": "さらに、ギフトカードやモバイルトップアップカードなど、より多くの引き出しオプションを模索しています。さらなるアップデートにご期待ください。",
    "key536": "Payoneer口座への引き出し方法は？",
    "key537": "Payoneerは、世界中のユーザーにサービスを提供する国際的な決済プラットフォームです。ほとんどの銀行送金とサードパーティの支払い方法をサポートしています。",
    "key538": "銀行カードを使ってPayoneer口座を作成することができます。その後、Payoneer口座から銀行カードに資金を送金する前に、取引プラットフォーム口座からPayoneer口座に出金してください。ただし、一定の手数料がかかります。",
    "key539": "Payoneerアカウントに引き出しを行うには、以下の手順に従ってください：",
    "key540": "Payoneerアカウントを設定します。.",
    "key541": "Payoneerの指示に従って、本人確認手続きを完了します。銀行カードまたは第三者の支払い方法をPayoneerアカウントにリンクします。",
    "key542": "取引プラットフォームの出金ページに移動し、プラットフォーム口座をPayoneer口座にリンクします（ログインが必要です）。",
    "key543": "出金リクエストを送信し、Payoneerアカウントに資金が入金されるのを待ちます。",
    "key544": "スイフトとローカルの違いは何ですか？",
    "key545": "スイフト」の送金方法は「ローカル」とは異なる。スウィフトは国際電信送金で、国境を越えた送金はコストが高く、到着も遅い。Localは現地での送金で、コストが安く、到着も早い。まずはローカルモードで送金することをお勧めします。",
    "key546": "なぜ引き出しができないのですか？",
    "key547": "取引プラットフォーム上のすべての引き出しは、プラットフォームと関係銀行によって審査されます。あなたの撤退要求が拒否される可能性のある理由は次のとおりです：",
    "key548": "お客様がプラットフォーム上で入力した銀行情報が、お客様の銀行情報と一致しない。",
    "key549": "あなたのアカウントは現在制限されています",
    "key550": "出金に関するご質問は、ヘルプセンター->カスタマーサービスまでお問い合わせください。",
    "key551": "最低引き出し額はいくらですか？",
    "key552": "銀行振込USD50",
    "key553": "電子財布USD50",
    "key554": "口座に入金されるまでどのくらいかかりますか？",
    "key555": "銀行振込：1～5営業日",
    "key556": "Payoneer: 1営業日",
    "key557": "出金手数料はいくらですか？",
    "key558": "支払いチャネル別の手数料：",
    "key559": "Payoneer：1％＋1ドル（最低2ドル）、実際の手数料は取引額によって異なります。",
    "key560": "銀行カード1％＋固定手数料（受取銀行により2.5～8ドル。通常、ローカル・トランザクションには2.5ドル、スイフト・トランスファーには8ドルが課金されます。出金やトップアップのリクエストには、ローカル・トランスファーをサポートする銀行カードの使用をお勧めします。）",
    "key561": "*お引出しの際に両替を伴う場合は、各銀行のリアルタイムの為替レートが適用され、別途手数料がかかる場合があります。",
    "key562": "*受取銀行によっては、銀行手数料やその他の手数料が別途かかる場合があります。詳しくは各銀行にご確認ください。",
    "key563": "*取引プラットフォームは、失敗した引き出し要求に対して手数料を徴収しないことにご注意ください。発生した手数料は、支払いチャネルまたは銀行によって請求されます。",
    "key564": "出金リクエストに対応している国/地域はどこですか？",
    "key565": "当プラットフォームが現在銀行送金をサポートしている国と地域（アルファベット順）：",
    "key566": "アルゼンチン, オーストラリア, オーストリア, ベルギー, ボスニア・ヘルツェゴビナ, ブラジル, ブルガリア, カンボジア, カナダ, チリ, コロンビア, コスタリカ, クロアチア, キプロス, チェコ共和国, デンマーク, エジプト, エストニア, フィンランド, フランス, グルジア, ドイツ, ギリシャ, グアテマラ, ハンガリー, アイスランド, インド, インドネシア, アイルランド, イスラエル, イタリア, 日本, カザフスタン、ラトビア、リトアニア、ルクセンブルク、マレーシア、マルタ、メキシコ、モルドバ、モロッコ、オランダ、ニュージーランド、北マケドニア、ノルウェー、パキスタン、パナマ、ペルー、フィリピン、ポーランド、ポルトガル、ルーマニア、ロシア、セルビア、シンガポール、スロバキア、韓国、スペイン、スウェーデン、スイス、タイ、トルコ、ウクライナ、UAE、英国、米国、ウルグアイ、ベトナム。",
    "key567": "プラットフォームが現在Payoneer出金に対応している国と地域：",
    "key568": "通常は全世界を対象とするが、実際の状況により変更される場合がある。",
    "key569": "7日間",
    "key570": "最終改訂[2024.01.01",
    "key571": "発効日［2024.01.01］",
    "key572": "クッキーと類似技術ポリシー",
    "key573": "[PlaySave](以下、「当社」または「当社」)は、[https://PlaySave.store](以下、「本サイト」)において、クッキーおよびその他の類似技術を使用しています。この「クッキーおよび類似技術に関する方針」（以下、「CST方針」）は、当社のプライバシー方針を補足するものであり、当社が本サイトに関連してクッキーおよび類似技術をどのように使用するかについて説明するものです。",
    "key574": "ご不明な点がございましたら、[support@PlaySave.store]までメールでお問い合わせください。",
    "key575": "クッキーおよび類似技術とは何ですか？",
    "key576": "クッキーは小さなファイルで、お客様のデバイスに配置されると、特定の機能や特徴を提供できるようになります。クッキーはウェブサイトの標準的な機能であり、お客様の本サイトへのアクセスに関する少量のデータをお客様のコンピュータに保存することができます。クッキーは、本サイトのどの部分が有用で、どの部分に改善が必要かを知るのに役立ちます。",
    "key577": "お客様は、ブラウザの設定を変更することにより、または本サイトの特定の設定を変更することにより（本CSTポリシーのセクション3に定めるとおり）、クッキーおよび類似技術の使用全般を受け入れるかどうかを選択することができます。ただし、Cookieおよび類似の技術を無効にした場合、本サイトでの利用体験が低下し、一部の機能が意図したとおりに動作しなくなる可能性があります。",
    "key578": "私たちはどのようなクッキーや同様の技術を使用していますか？",
    "key579": "「以下では、当社が本サイトの運営に使用するさまざまな種類のクッキーおよび類似技術を列挙します。クッキーは、当社がお客様のデバイスに直接提供する場合（ファーストパーティークッキー）と、当社に代わって第三者が提供する場合（サードパーティークッキー）があります。クッキーは、ブラウザを閉じると失効する一時的なもの（「セッション」クッキー）と、ブラウザを閉じた後もお客様のデバイスに保存される永続的なもの（「永続」クッキー）があります。",
    "key580": "エッセンシャル・クッキー",
    "key581": "必要なクッキーは、本サイトの運営に不可欠です。当社は、サイトの表示、ネットワークの管理、または適用される法律の遵守のためにこれらのクッキーを使用します。以下のクッキーは、お客様が本サイトを利用する際に常に設定されます：",
    "key582": "クッキー名",
    "key583": " 目的",
    "key584": "永続的クッキーとセッション・クッキー永続的クッキーの有効期限はいつですか？",
    "key585": "ファーストパーティ（訪問先のサイトが設定）か、サードパーティ（異なるサイト間）か？",
    "key586": "ACCEPT_ESSENTIAL",
    "key587": "このクッキーは、ユーザーが必要なクッキーを受け入れたかどうかを記録するために使用されます。",
    "key588": "Persistent",
    "key589": "1st party ",
    "key590": "ACCEPT_ANALYTICAL",
    "key591": "このクッキーは、ユーザーが分析クッキーを受け入れたかどうかを追跡するために使用されます。",
    "key592": "psトークン",
    "key593": "このクッキーは、お客様のアカウントを確認し、お客様がいつログインされたかを判断するために使用します。これにより、お客様が当社のウェブサイトにアクセスしやすくなり、適切な体験や機能を表示できるようになります。",
    "key594": "インストール・クーポン",
    "key595": "このクッキーは、ユーザーがPWAクーポンを請求したかどうかを記録するために使用されます。",
    "key596": "ノーモア・プロンプト",
    "key597": " このクッキーは、再度促す必要のない情報を理解するために、ユーザーの確認を記録するために使用されます。",
    "key598": " device_id（ローカルストレージ）",
    "key599": " このクッキーは、通知を送信するためのデバイスIDを記録するために使用されます。",
    "key600": "プリファレンス・クッキー。環境設定クッキーは、お客様の選択や好みに関する情報を収集し、言語やその他のローカル設定を記憶して、それに応じてサイトをカスタマイズできるようにします。",
    "key601": "目的",
    "key602": "クッキーは永続的ですか、それともセッションクッキーですか？永続的クッキーの有効期限はいつですか？",
    "key603": " 1stパーティ（訪問しているサイトによって設定される）または3rdパーティ（異なるサイトにまたがる）？サードパーティを示す（完全な法的名称とクッキーポリシーへのURL）",
    "key604": "ログイン非表示",
    "key605": "このクッキーは、ログインボックスを隠すかどうかを記録するために使用されます。",
    "key606": "1日",
    "key607": "ステイ_ログイン",
    "key608": "このクッキーは、「ログイン状態を維持する」オプションがチェックされているかどうかを記録するために使用されます。",
    "key609": "ログインチャンネル",
    "key610": "このクッキーは、ログイン方法を記録するために使用されます。",
    "key611": "レイアウト済み",
    "key612": "このクッキーは、ユーザーが左メニューを折りたたんだかどうかを記録するために使用されます。",
    "key613": "インベントリー・ナイフアウト・トースト",
    "key614": "このクッキーは、オンシェルフ・プロンプトがホームページに表示されたかどうかを記録するために使用されます。",
    "key615": "選択言語",
    "key616": "このクッキーは、ユーザーが選択した優先言語を記録するために使用されます。",
    "key617": "セレクトカレンシー",
    "key618": "このクッキーは、ユーザーが選択した優先通貨を記録するために使用されます。",
    "key619": "アナウンスID",
    "key620": "このクッキーは、ユーザーがアナウンスを閉じたかどうかを記録するために使用されます。",
    "key621": "リチャージ・ポーリング",
    "key622": "このクッキーは、進行中のリチャージ注文IDを記録し、注文ステータスの表示を更新するために使用されます。",
    "key623": "チェックアウトカード通知",
    "key624": "このクッキーは、カードの最初のバインディング時にプロンプトが表示されたかどうかを記録するために使用されます。",
    "key625": "チェックアウト・ソース・ポーリング",
    "key626": "このクッキーは、進行中のカードバインディングIDの保留中のクエリーを記録し、カードバインディングのステータス表示を更新するために使用されます。",
    "key627": "投票辞退",
    "key628": "このクッキーは、進行中の出金注文のIDを記録し、注文ステータスの表示を更新するために使用されます。",
    "key629": "トップページ",
    "key630": "このクッキーは、リチャージ時にユーザーが記入したフォームの内容を記録し、次回以降の購入時の自動記入を容易にするために使用されます。",
    "key631": "トップページ",
    "key632": "このクッキーは、ユーザーがリチャージページのプロンプトを閉じたかどうかを記録するために使用されます。",
    "key633": "パフォーマンス/アナリティクスクッキーパフォーマンスクッキー（アナリティクスクッキーを含む）は、（例えば）訪問回数やトラフィックソースのカウント、最も人気のあるページと最も人気のないページの表示、訪問者がサイト内をどのように移動しているかの追跡などにより、本サイトがどのように機能しているか、訪問者は誰か、どのように本サイトを利用しているかを把握するのに役立ちます。これには、お客様が閲覧したページ、参照ページおよび終了ページ、お客様の訪問日時、訪問時間など、お客様が当社サイトをどのように利用されたかに関する情報が含まれます。また、（IPアドレスから推測される）お客様の都市や国などの一般的な位置情報を収集することもあります。",
    "key634": "具体的には、Google, Inc.（以下「Google」）が提供するウェブ解析サービスであるGoogle Analyticsを使用しています。GoogleはCookieを使用して、ユーザーの行動（クリックイベント、ページビュー、位置情報など）を追跡し、ユーザーの本サイトの利用状況を把握・分析しています。Cookieによって生成されたお客様の本サイトの利用に関する情報（IPアドレスを含む）は、Googleによって米国内のサーバーに送信され、保存されます。Google Analytics Cookieの詳細については、Googleのヘルプページおよびプライバシーポリシーをご覧ください。",
    "key635": "クッキーや類似技術を管理するにはどうすればよいですか？",
    "key636": "お客様は、当社のCookies Preference Centerを通じて、いつでも同意の撤回を含め、ファーストパーティクッキーの設定を変更することができます：",
    "key637": "Googleのブラウザプラグインをダウンロードしてインストールすることで、Google分析による情報収集や使用を防ぐことができます。",
    "key638": "お使いのブラウザでは、すべてのクッキーを削除したり、特定のサイトからのクッキーのみを許可したり、クッキーが送信されるタイミングを表示したりすることができます。一般的なブラウザでクッキーを管理する方法については、以下をご覧ください：Internet Explorer、Firefox、Chrome、Safari（iOS）、Safari（Mac）、Opera。本サイトが正しく機能しなくなるため、必要なクッキーを無効にすることはできません。どのようなクッキーが設定されているかを確認する方法など、クッキーの詳細については、www.aboutcookies.org または www.allaboutcookies.org をご覧ください。クッキーを無効にした場合、本サイトのすべての機能が意図どおりに動作しない可能性があることにご注意ください。",
    "key639": "追跡禁止",
    "key640": "「Do Not Track」（「DNT」）は、ユーザーが特定のウェブブラウザで設定できるプライバシー設定です。DNTは、ユーザーがWebサイトに対して、Webページの閲覧に関する特定の情報を、長期的かつ複数のWebサイトやオンラインサービスにわたって収集されることを望まないことを通知するための方法です。Do Not Trackについての詳細はこちらをご覧ください。ウェブブラウザがこの機能をどのように組み込み、有効化するかには違いがあるため、当社は現在、これらのシグナルに対応するアクションをとっていません。",
    "key641": "本クッキーポリシーの変更",
    "key642": "本CSTポリシーは変更されることがあります。本CSTポリシーを定期的に確認し、改訂または修正することをお勧めします。",
    "key643": "アバターを交換",
    "key644": "アフィリエイト・プログラムに申し込む",
    "key645": "交通協定",
    "key646": "はじめに",
    "key647": "本トラフィックアライアンス契約は、適用されるスケジュール（報酬スケジュールを含むがこれに限定されない）と共に（以下「本契約」と総称する）、GEARUP PORTAL PTE.LTD.が所有し運営する、現在https://www.PlaySave.store（以下「本プラットフォーム」と称する）にあるプラットフォームを利用するために、パートナー（以下「パートナー」と称する）との間で締結される。LTD.(以下「PlaySave」という。)との間で締結される。本契約は、プラットフォームが提供するトラフィックアライアンスプログラムに関連して、PlaySaveとパートナーとの間の条件を定めるものです。本規約は、PlaySaveとパートナーとの間で締結された同内容に関する書面による合意によりその全部または一部が置き換えられた場合を除き、パートナーに適用されるものとします。",
    "key648": "広告キャンペーンの機会",
    "key649": "トラフィックアライアンスプログラムでは、PlaySaveの役割は主に、パートナー向けの広告キャンペーン機会（それぞれ「キャンペーン」）を提案および設定し、パートナーに当該キャンペーンへの参加を呼びかけることです。適用される報酬スケジュール（以下に定義）を含む各新規キャンペーンの詳細は、プラットフォームのウェブサイトに記載されます。誤解を避けるため、PlaySaveはいかなる機会またはキャンペーンも保証せず、各機会は非独占的にパートナーと共有されます。",
    "key650": "プロモーションとペイアウトのトラッキング",
    "key651": "パートナーは、本プラットフォームへのトラフィックの誘導に成功した場合、および/または本プラットフォームの商品およびサービスを調達するためにユーザーを紹介した場合に報酬を受け取る。適用される報酬スキームは、[ウェブサイト]にある本契約のスケジュール（「報酬スケジュール」）に記載されるものとする。リワードスケジュールは、パートナーがリワードスケジュールで指定された特定のプラットフォームのバーチャルクレジット（「ペイアウト」）を獲得するためのアクション（「アクション」）および資格パラメータ（「条件」）を指定するものとする。ペイアウトは、アクションが完了し、条件が満たされたことをプラットフォームが独自の裁量で承認することを条件とします。リワードスケジュールは、プラットフォームのビジネスニーズに基づいて、プラットフォームが独自の裁量で随時更新することができます。アクションのトラッキングおよびペイアウトの計算に関するすべてのトラッキングおよび支払い処理機能は、PlaySaveが提供し、引き受けるものとします。パートナーは、PlaySaveが書面で明示的に承認しない限り、または報酬スケジュールに定めない限り、以下の手段を用いてキャンペーンを促進するために資料を使用してはならないものとします。(b)アクションを生成するための偽のリダイレクト、自動化ソフトウェア、またはその他のメカニズムの使用 (c)自動化装置、ロボット、Iframe、または隠しフレームを使用したものなど、善意ではないアクション；(d) エンドユーザーからアクションを調達するためにインセンティブを使用すること、または (e) 類似のプラットフォームやゲームでの購入/取引行動が本物でない、または不正であるユーザー、例えば、高額なチャージバックやその他の異常な行動の履歴があることが知られているユーザーを推薦すること。",
    "key652": "知的財産と守秘義務",
    "key653": "ライセンス：本規約の条件に従い、PlaySaveはパートナーに対し、各キャンペーンの期間中、本規約に定める義務の履行に必要な範囲に限り、PlaySaveが提供する資料（以下「資料」といいます）を使用するための取消可能、非独占的、譲渡不能、世界的、ロイヤリティフリーのライセンスを付与します。",
    "key654": "知的財産：「知的財産」とは、商標（登録、未登録を問わず、それらに関連するすべての営業権を含む）、未登録および登録意匠、著作権、データベース権、コンピュータソフトウェアの権利、ドメイン名、秘密情報の権利（以下に定義）、その他すべての知的財産権（現在存続しているか、将来創出されるかを問わない）を意味します。パートナーが本契約を受諾した開始日以前に存在した知的財産権は、当該開始日の直前に当該権利を有していた当事者に帰属するものとします。PlaySaveは、本プラットフォームのウェブサイトおよびプラットフォーム、マテリアル、および適用される報酬スケジュールを含むすべてのキャンペーンに存在する知的財産のすべての権利、利益および権原を所有するものとし、パートナーは、PlaySaveの知的財産に対する権原を取得または主張しないことを認め、同意するものとする。",
    "key655_1":"機密情報： ",
    "key655": "「秘密情報」とは、企業秘密、財務情報、技術情報、顧客、価格、割引、マージンなど、有形無形を問わず、すべての秘密情報およびデータを意味する。PlaySave および/または他のパートナー（以下「開示側」）から秘密情報を受領したパートナー（以下「受領側」）は、(a) すべての秘密情報を秘密に保持し、受領側が自身の秘密情報を保護するのと同程度の注意をもって保護すること、(b) 当該秘密情報を本契約の目的および本契約で許可された範囲でのみ使用すること；(d) 当該秘密情報の開示を、本契約の目的のために当該秘密情報を知る必要があり、かつ当該秘密情報を保護するよう書面により拘束される従業員および代理人のみに制限すること。前述の義務は、秘密として指定された情報については適用されない：秘密保持義務を負うことなく受領当事者が既に知っていた場合、受領当事者の不正な行為により公知となった場合、開示当事者の秘密情報を参照することなく受領当事者が独自に開発した場合、秘密保持義務を負うことなく第三者から受領した場合、秘密保持義務を負うことなく開示当事者が第三者に開示した場合、または開示当事者の書面による事前承認により公開が承認された場合。 受領当事者が、裁判所の命令、政府機関の要請、またはその他の法的手続きに基づき、開示当事者の秘密情報の開示要求を受けた場合、受領当事者は、開示当事者に速やかに通知し、開示が要求される秘密情報のいかなる部分も、裁判所が命令を出した目的またはその他の法律で要求される目的のみに使用することを要求する保護命令を取得するために、開示当事者を合理的に支援するものとします。各パートナーは、これに関連する弁護士費用を負担するものとする。",
    "key656": "表明、免責および補償",
    "key657": "表明および保証： (a) 各パートナーは、以下の事項を保証し、表明し、約束する：(i)パートナーは、本契約における義務を履行する全権限および権限を有すること、(ii)本契約に基づく義務の締結および履行は、第三者の権利を侵害せず、または第三者に対する義務違反を引き起こさないこと、(iii)本契約に基づく義務の履行において、適用されるあらゆる法律、規則および規制を完全に遵守すること。",
    "key658": "補償：各パートナー（以下「被補償者」）は、PlaySaveおよび他のパートナー、ならびにそれぞれの株主、取締役、役員、従業員、下請業者および代理人（以下、総称して「被補償者」）を、被補償者の本契約違反により第三者から被った、請求された、または被ったすべての請求、訴訟、費用、損害賠償責任、費用（合理的な弁護士費用を含む）、和解および判決（以下「請求」）から防御し、補償し、損害を与えないものとします：(a)被補償者は、賠償請求の通知受領後、商業的に合理的な期間内に書面で補償者に通知すること、(b)補償者は、弁護および関連するすべての和解交渉を単独で管理すること（ただし、補償者は、被補償者の合理的な同意なしに、被補償者の過失を認めるような方法で賠償請求を解決してはならない）、および(c)被補償者は、本条項に基づく義務を履行するために必要な合理的な支援、情報および権限を補償者に提供すること。被補償者は、被補償者の費用負担で請求の弁護に参加することができ、このような参加は、本条に基づく被補償者の義務を放棄または軽減するものではありません。",
    "key659": "責任の制限： (a) 以下のいかなる規定も、法律上除外または制限することができない責任（以下、総称して「除外損失」）を除外または制限するために機能するものではありません。(b) 除外された損失に関する場合を除き、契約、不法行為（過失、法定義務違反、不実表示、その他を含む）、その他のコモンローまたは法定訴因、または本契約および各報奨スケジュールに関連して生じるその他の訴因に対する各当事者の他の当事者に対する責任は、報奨スケジュールに従ってPlaySaveが実際に支払ったペイアウトおよび/またはその他の手数料に限定されるものとします。(c) 除外された損失に関する場合を除き、いずれの当事者も、契約、不法行為（過失を含む）またはその他において、実際のまたは潜在的な利益、契約、顧客の損失、データの損失、データまたはその他の修復の引き受け、評判の損失、過失、契約違反またはその他に起因するか否かを問わず、その他の間接的、結果的、特別、懲罰的、懲罰的損害賠償について、相手方に対して責任を負わないものとします。",
    "key660": "一般",
    "key661": "救済措置の放棄：PlaySaveによる本契約の条項の行使または執行の留保または遅延は、PlaySaveの権利を毀損または制限するものではなく、その権利の放棄は、その後の違反の放棄として機能しないものとする。本契約において、いずれかの当事者に付与または留保された、または法律により利用可能ないかなる権利、権限または救済措置も、当該パートナーが利用可能なその他の権利、権限または救済措置の排他的なものではなく、かかる権利、権限または救済措置はそれぞれ累積的なものとする。",
    "key662": "譲渡：パートナーは、本契約に基づく権利および義務の一部または全部を第三者に譲渡または再委託してはならない。",
    "key663": "通知：本契約に基づき行う必要のある通知は、すべて書面（電子メールまたはその他の電子的手段で足りるものとします）で行うものとします。",
    "key664": "完全合意：本契約は、本契約の主題に関する完全な理解を表し、完全な合意を構成するものであり、本契約のかかる主題に関する従前の合意に取って代わるものであり、両当事者によって締結された書面によってのみ修正することができる。各当事者は、本契約に明示的に規定されている以外の表明または保証に依存していないことを認め、これに同意するものとします。",
    "key665": "電子署名：各当事者は、本契約の受諾をクリックスルーすることにより、承認された電子署名を提出し、法的拘束力のある契約を締結することを認め、同意するものとします。さらに、各当事者は、本契約により、あらゆる司法管轄区において適用される法令、規制、規則、条例、またはその他の法律に基づき、電子的手段以外の方法による支払いまたはクレジットの付与に対して、原本署名、電子的手段以外の記録の交付または保持を要求する権利または要件を放棄するものとします。",
    "key666": "分離可能性：本契約のいずれかの条項の全部または一部が、管轄権を有する裁判所または行政機関により、制定法または法律の規則の下で違法、無効、または執行不能であると判断された場合、その条項または部分は本契約の一部を構成しないものとみなされ、本契約の残りの部分の執行可能性および有効性は影響を受けないものとします。両当事者は、無効とされた条項または部分を修正し、両当事者の表明された意図を実現するよう誠意をもって努めるものとします。",
    "key667": "存続：その性質上、本契約の終了または失効後も存続すると合理的に解釈されるべきすべての条項は、本契約の終了または失効後も存続するものとします。",
    "key668": "両当事者の関係：パートナーの関係は独立した請負業者であり、本契約は両者の間にいかなる団体関係、パートナーシップ関係、合弁関係または代理関係をも生じさせない。いずれのパートナーも、他方を拘束したり、他方に対して何らかの責任を生じさせたりする権限を有しない。",
    "key669": "協定に同意し、アクティベートする",
    "key670": "パスワードの変更",
    "key671": "私のプロモーション・リンク",
    "key672": "デフォルトリンク",
    "key673": "コピーリンク",
    "key674": "私のプロモーション収入",
    "key675": "決済金額",
    "key676": "累計額",
    "key677": "決済保留額",
    "key678": "収入詳細",
    "key679": "ユーザー詳細",
    "key680": "辞退",
    "key681": "ログアウト",
    "key682": "収入記録はまだありません",
    "key683": "まだアカウントをお持ちでないのですか？",
    "key684": "アカウントをお持ちですか？",
    "key685": "アカウント登録またはログインすることにより、以下の事項に同意したものとみなされます。",
    "key686": "ログインしてフルサービスをお楽しみください！",
    "key687": "完全なパスワードを入力",
    "key688": "2回入力したパスワードに矛盾がある！",
    "key689": "電子メールを入力してください",
    "key690": "無効な電子メール",
    "key691": "コードを入力してください",
    "key692": "完全なパスワードを入力",
    "key693":"認証コード",
    "key694":"認証コードは10分以内に有効なメールボックスに送信されました",
    "key695":"新しいパスワード",
    "key696":"取引情報、アカウントセキュリティなどの重要な情報を受信するために電子メールをバインドしてください。",
    "key697":"せつぞく",
    "key698":"playsave.comの詳細なサービスにアクセスするには、Googleアカウントをバインドしてください。"
}
